import { isDestroyed, isDestroying } from '@ember/destroyable';
import DS from 'ember-data';

export default function (destroyable: object): boolean {
  let destroyedOrDestroying = isDestroyed(destroyable) || isDestroying(destroyable);

  if (destroyable instanceof DS.Store) {
    // Destroyed store doesn't seem to be detected by the base
    // "@ember/destroyable" utils func - very weird!
    // Test: http://127.0.0.1:4200/tests?testId=390272b4

    // To workaround check ".isDestroyed"/".isDestroying" properties by hand:
    destroyedOrDestroying = destroyedOrDestroying || destroyable?.isDestroyed || destroyable?.isDestroying;
  }

  return destroyedOrDestroying;
}
